<template>
  <div class="activity-item m-2">
    <div class="row m-2">
      <div class="col-12">
        <activity-po-wo-wrapper :rfqID="data.rfqID" :handleAutoSave="handleAutoSave">
          <template v-slot:default="{autoSaveMiddleware}">
            <activity-top-form
              :supplierError="supplierError"
              :data="data"
              :model="formModel"
              @onAutoSave="autoSaveMiddleware"
            />
            <!-- FORM -->
            <activity-form
              :subjectError="subjectError"
              :displayActivityLog="displayActivityLog"
              :data="data"
              :model="formModel"
              :disabledNewInstruction="!hasActivityLog"
              @onAutoSave="autoSaveMiddleware"
              @onStatusEmail="handleStatusRequestEmail"
              @onNewInstruction="handleNewInstruction"
            >
              <template v-slot:user-actions>
                <slot name="user-actions"></slot>
              </template>
              <template v-slot:log-list>
                <activity-info-log
                  :style="{'min-width': displayActivityLog ? 'unset' : '40rem'}"
                  ref="activity-info"
                  :activityID="data.id"
                  apiGet="RepairExchangeOrderFollowUpLogs/GetAllDynamic"
                  apiCreate="RepairExchangeOrderFollowUpLogs/Create"
                  :Model="activityLogModel"
                  :params="activityLogParams"
                  @onUpdateCount="handlerUpdateCountActivityLog"
                >
                  <template v-slot:dialog-info>
                    <el-form>
                      <el-form-item
                        :label="L10n('last-info')"
                        class="material-style"
                        prop="lastInfo"
                      >
                        <el-input
                          type="textarea"
                          :rows="5"
                          :value="item.lastInfo"
                          disabled
                        >
                        </el-input>
                      </el-form-item>
                    </el-form>
                  </template>
                </activity-info-log>
              </template>
            </activity-form>
          </template>
        </activity-po-wo-wrapper>
      </div>
    </div>
  </div>
</template>

<script>

import { ServiceRepairExchangeOrderFollowUp } from '@/services/RepairExchangeOrderFollowUp'

export default {
  name: 'ActivityItem',
  components: {
    'activity-top-form': () => import(/* webpackChunkName: 'ActivityTopFormPoWo' */ '../ActivityTopFormPoWo/Index'),
    'activity-po-wo-wrapper': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/ActivityPoWoWrap/index'),
    'activity-form': () => import(/* webpackChunkName: 'Shared' */ './Form'),
    'activity-info-log': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/ActivityLog/Index')
  },
  props: {
    autoSave: { type: Function, required: true },
    displayActivityLog: { type: Boolean, default: false },
    data: { type: Object, required: true },
    item: { type: Object, required: true },
    formModel: { type: Function, required: true }
  },
  data () {
    return {
      isLoading: false,
      hasActivityLog: false,
      supplierError: null,
      subjectError: null
    }
  },
  computed: {
    activityLogParams () {
      return {
        'select': `id,repairExchangeOrderFollowUpID,entryDate,employeeID,description,isEmployeeEntry,isRead,employee.name as employeeName`,
        'filter': `repairExchangeOrderFollowUpID == ${this.data.id}`,
        'orderBy': `id desc`
      }
    },
    currentEmployee () {
      return this.$store.getters.get('currentEmployee')
    }
  },
  methods: {
    async handleAutoSave (props) {
      const { label, ...rest } = props
      this.autoSave(rest)
        .then(({ e, config }) => {
          const id = this.data.id
          const { field, value } = props
          if (!e) {
            this.updateLog({ field, id, labelSelect: label, value })
          }
        })
    },
    async updateLog ({ field, id, labelSelect, value }) {
      await ServiceRepairExchangeOrderFollowUp
        .updateNotification({ field, id, labelSelect, value })
      this.$refs['activity-info'].loadList()
    },
    activityLogModel () {
      return {
        id: null,
        repairExchangeOrderFollowUpID: this.data.id,
        entryDate: new Date(),
        employeeID: this.$store.getters.get('currentUser').employeeID,
        description: '',
        isEmployeeEntry: true,
        isRead: false
      }
    },
    handlerUpdateCountActivityLog (count) {
      this.hasActivityLog = !!count
    },
    handleStatusRequestEmail ({ subject }) {
      this.validateStatusRequestEmail({ subject })
        .then(() => {
          this.$bus.$emit('on-status-email-request-repair-order', { subject, id: this.data.id },
            (emailData) => {
              let logData = {
                description: `Status sent to ${emailData.supplierContactName}: ${emailData.subject}`
              }
              this.createLog(logData)
            }
          )
        })
        .catch((err) => {
          this.validateErrorHandler(err)
        })
    },
    async validateStatusRequestEmail ({ subject }) {
      this.supplierError = null
      this.subjectError = null

      if (!this.item.supplierContactID) {
        let text = this.L10n('need-to-select-contact')
        this.supplierError = text
        return Promise.reject(new Error(text))
      }

      if (!subject) {
        let text = this.L10n('need-to-select-subject')
        this.subjectError = text
        return Promise.reject(new Error(text))
      }

      return Promise.resolve()
    },
    handleNewInstruction ({ subject }) {
      this.$bus.$emit('on-new-instruction-repair-order', { subject, id: this.data.id },
        (emailData) => {
          let logData = {
            description: `Sent new instruction to support`
          }
          this.createLog(logData)
        }
      )
    },
    createLog (data) {
      let _data = {
        repairExchangeOrderFollowUpID: data.repairExchangeOrderFollowUpID || this.data.id,
        employeeID: this.currentEmployee.id,
        entryDate: data.date,
        description: data.description
      }

      _data = this.copyObjectProps(this.activityLogModel(), _data)
      this.$refs['activity-info'].createItem(_data)
    }
  }
}
</script>
